import React from "react";
import { useSelector } from "react-redux";
import SidebarLogo from "./parts/SidebarLogo";
import SidebarMenu from "./parts/SidebarMenu";

const DashboardSidebar = ({ children }) => {
	const showSidebar = useSelector(state => state.sidebar.showSidebar);
	return (
		<div
			className={`admin-sidebar top-0 sticky bg-blue h-screen flex flex-col w-[calc(250/1920*100*1rem)] shrink-0 ${
				showSidebar && "isShow"
			}`}>
			<SidebarLogo></SidebarLogo>
			<SidebarMenu></SidebarMenu>
		</div>
	);
};

export default DashboardSidebar;
